/*
 * @Author: vicshang
 * @Date: 2020-08-20 15:39:32
 * @Last Modified by: zhaopeng
 * @Last Modified time: 2023-05-11 19:51:06
 * 辅助函数
 */
const getDataFromConfig = (config) => {
  const data = {};
  for (let i = 0; i < config.length; i++) {
    const { type, key } = config[i];
    if (type && type == 'image') {
      data[key] = [];
    } else {
      data[key] = '';
    }
  }
  return data;
};
export {
  getDataFromConfig
};
